module.exports = __webpack_public_path__ + "static/media/verbs_in_ui1.0b55ee49.JPG";